import React from 'react';
import { cn } from '../../../utils/cn';
import ChangelogViewer from '../../ChangelogViewer';

interface AvisosPanelProps {
  onBack?: () => void;
  lightTheme?: boolean;
}

const AvisosPanel: React.FC<AvisosPanelProps> = ({ onBack, lightTheme }) => {
  return (
    <div className={cn('flex flex-col h-full overflow-hidden', lightTheme ? 'bg-white' : 'bg-[#0d0d10]')}>
      <ChangelogViewer lightTheme={lightTheme} onBack={onBack} />
    </div>
  );
};

export default AvisosPanel;
